import { render, staticRenderFns } from "./CustomerShippingAddressCreateDrawer.vue?vue&type=template&id=7f3c22cb"
import script from "./CustomerShippingAddressCreateDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerShippingAddressCreateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports